import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, Shield } from "lucide-react";
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL + "/api/admin";

export default function AdminLoginPage() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${BASE}/login`, { password });
      if (res.data.token) {
        sessionStorage.setItem("nt_admin_token", res.data.token);
        navigate("/admin/dashboard");
      }
    } catch {
      setError("Hibás admin jelszó. Kérjük próbálja újra.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6"
      style={{ background: "#FDF5EB", fontFamily: "Quicksand, sans-serif" }}
    >
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div
            className="w-12 h-12 flex items-center justify-center"
            style={{ background: "#242220", borderRadius: "16px", border: "1.5px solid #242220" }}
          >
            <Leaf size={22} color="#FBD556" strokeWidth={2.5} />
          </div>
          <div>
            <p className="font-bold text-lg leading-tight" style={{ color: "#242220" }}>NaturTrak LMS</p>
            <p className="text-xs" style={{ color: "#242220", opacity: 0.5 }}>Admin felület</p>
          </div>
        </div>

        <div
          className="p-8"
          style={{
            background: "#fff",
            borderRadius: "24px",
            border: "1.5px solid #242220",
            boxShadow: "6px 6px 0 #242220",
          }}
        >
          <div
            className="w-14 h-14 flex items-center justify-center mx-auto mb-6"
            style={{ background: "#FF9456", borderRadius: "18px", border: "1.5px solid #242220" }}
          >
            <Shield size={24} strokeWidth={2.5} color="#242220" />
          </div>
          <h2 className="text-2xl font-bold text-center mb-1" style={{ color: "#242220" }}>
            Admin Bejelentkezés
          </h2>
          <p className="text-sm text-center mb-6" style={{ color: "#242220", opacity: 0.5 }}>
            Kurzuskezelő felület
          </p>

          {error && (
            <div
              className="p-3 mb-4 text-sm font-bold text-center"
              style={{ background: "#FDECEA", border: "1.5px solid #D32F2F", borderRadius: "14px", color: "#D32F2F" }}
              data-testid="admin-login-error"
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold mb-2" style={{ color: "#242220" }}>
                Admin jelszó
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="w-full px-4 py-3 text-sm outline-none"
                style={{
                  background: "#FDF5EB",
                  borderRadius: "16px",
                  border: "1.5px solid #242220",
                  fontFamily: "Quicksand, sans-serif",
                  color: "#242220",
                }}
                data-testid="admin-password-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 font-bold text-base transition-all active:translate-x-[2px] active:translate-y-[2px]"
              style={{
                background: "#FBD556",
                borderRadius: "30px",
                border: "1.5px solid #242220",
                boxShadow: "4px 4px 0 #242220",
                color: "#242220",
                cursor: loading ? "not-allowed" : "pointer",
              }}
              data-testid="admin-login-btn"
            >
              {loading ? "Belépés..." : "Belépés"}
            </button>
          </form>
        </div>
        <p className="text-center text-xs mt-4" style={{ color: "#242220", opacity: 0.4 }}>
          <a href="/" style={{ color: "#242220" }}>← Vissza a főoldalra</a>
        </p>
      </div>
    </div>
  );
}
